import styled, { css } from 'styled-components';
import { Media, TextStylesMobile, TextStylesDesktop, Colors } from 'enums';

type ITextAreaStyled = {
  error?: string;
  disabled?: boolean;
};

export const TextAreaWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  row-gap: 4px;
  justify-content: flex-start;
  text-align: left;
  border: none;
  border-radius: 8px;
`;

export const StyledTextOverlay = styled.div`
  ${TextStylesMobile.body}

  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 24px 16px;
  box-sizing: border-box;
  overflow-y: auto;
  white-space: pre-wrap; /* Preserve whitespace and line breaks */
  word-break: break-word; /* Break long words to prevent overflow */
  pointer-events: none; /* Allow clicks to pass through to the textarea */
  color: transparent; /* Hide the actual text in the overlay */

  @media ${Media.notebook} {
    padding: 26px 24px;
    ${TextStylesDesktop.body}
  }
`;

export const StyledUrlSpan = styled.span`
  color: #3854e1;
  text-decoration: none;
`;

export const StyledTextArea = styled.textarea<ITextAreaStyled>`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 0 16px 24px;
  overflow-y: auto;

  ${TextStylesMobile.body}
  color: ${Colors.gray1};

  border: none;
  border-top: 24px solid transparent;
  border-radius: inherit;

  background-color: ${Colors.white};

  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  resize: none;

  &:hover {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'text')};
  }

  &::-ms-reveal {
    display: none;
  }

  &:focus {
    outline: 1px solid ${Colors.yellow1};
  }

  &::placeholder {
    color: ${Colors.gray2};
  }

  @media ${Media.notebook} {
    padding: 0 24px 26px;
    border-top-width: 26px;
    ${TextStylesDesktop.body}
    background-color: ${Colors.background};

    &:hover {
      background-color: ${Colors.background};
    }

    &:focus {
      background-color: ${Colors.white};
    }
  }

  ${({ error }) =>
    error &&
    css`
      outline: 1px solid ${Colors.red1} !important;
    `}
`;

export const StyledSubLabel = styled.p`
  ${TextStylesMobile.small1}
  color: ${Colors.gray3};
  margin: 4px 0 0 0;

  @media ${Media.notebook} {
    ${TextStylesDesktop.small1}
  }
`;

export const IconBox = styled.div`
  position: absolute;

  top: 12px;
  left: 16px;

  @media ${Media.notebook} {
    left: 26px;
  }
`;
